import React, { useState } from 'react';
import { Tooltip } from 'devextreme-react/tooltip';

interface FieldFlagIconProps {
    src: string;
    alt: string;
    hint: string;
}

/**
 * A small flag icon (primary key / mandatory) shown next to a field type tag, with a
 * DevExtreme Tooltip that explains what the icon means on hover.
 */
const FieldFlagIcon: React.FC<FieldFlagIconProps> = ({ src, alt, hint }) => {
    // The Tooltip needs the icon DOM node as its target. Multiple icons render per grid, so a
    // shared CSS selector would be ambiguous: keep a per-instance element reference instead.
    const [target, setTarget] = useState<HTMLElement | null>(null);

    // The Tooltip renders its own anchor node in the DOM flow. Wrapping it (and the icon) in a
    // fixed 22x22 box keeps that node from being counted as an extra flex item in the parent
    // row, which otherwise nudges the next icon sideways when the tooltip activates.
    return (
        <span style={{ display: 'inline-block', width: 22, height: 22, lineHeight: 0 }}>
            <img
                ref={setTarget}
                width={22}
                height={22}
                style={{ padding: 0, margin: 0, display: 'block' }}
                src={src}
                alt={alt}
            />
            {target && (
                <Tooltip
                    target={target}
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    position="top"
                    hideOnOutsideClick={false}
                    contentRender={() => <span style={{ fontSize: 12 }}>{hint}</span>}
                />
            )}
        </span>
    );
};

export default FieldFlagIcon;
